import React, { useEffect, useState } from 'react';
import { StyleSheet, View, Text, FlatList, Pressable, TouchableOpacity, Alert, SafeAreaView, Dimensions, ScrollView } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import Fondo from '../modules/component/Fondo';

import ButtonGradient from '../modules/component/ButtonGradient';

import { Table, TableWrapper, Row, Rows, Col, Cols, Cell } from 'react-native-table-component';
import { BarChart } from 'react-native-chart-kit';
import { apiFetch } from '../modules/api';




const backAction = () => {





  if (gPantalla.name == "DashboardRuta") {

    Alert.alert('Salir de la aplicación', '¿Esta seguro que quiere salir de la aplicación?', [
      {
        text: 'Cancelar',
        onPress: () => null,
        style: 'cancel',
      },
      { text: 'SI', onPress: () => BackHandler.exitApp() },
    ]);

    return true;

  }

};



const DashboardRuta = () => {

  const [ventaOb, setVentaOb] = useState('')
  const [ventaAv, setVentaAv] = useState('')
  const [ventaReal, setVentaReal] = useState('')
  const [exhibicionOb, setExhibicionOb] = useState('')
  const [exhibicionReal, setExhibicionReal] = useState('')
  const [exhibicionAv, setExhibicionAv] = useState('')
  const [ventaCeroTotal, setVentaCeroTotal] = useState('')
  const [ventaCeroReal, setVentaCeroReal] = useState('')
  const [ventaCeroAv, setVentaCeroAv] = useState('')
  const [ventaCeroOb, setVentaCeroOb] = useState('')
  const [rutaTotal, setRutaTotal] = useState('')
  const [rutaReal, setRutaReal] = useState('')
  const [rutaAv, setRutaAv] = useState('')
  const [rutaOb, setRutaOb] = useState('')

  const [ventaAvn, setVentaAvn] = useState(0);
  const [exhibicionAvn, setExhibicionAvn] = useState(0)
  const [ventaCeroAvn, setVentaCeroAvn] = useState(0)
  const [rutaAvn, setRutaAvn] = useState(0)
  const [boton, setBoton] = useState(0)

  async function fetchData() {

    var datos = '{"empresa" : "' + gEmpresa + '","usuario" : "' + gUsuario + '"}'


    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + gToken
      },
      body: datos

    }

    try {
      const response = await apiFetch(gApiPath + "/api/objetivosRuta", requestOptions);
      const json = await response.json();
      setVentaOb(json.datos["venta_objetivo_conf"]);
      setVentaReal(json.datos["venta_real"]);
      setVentaAv((parseInt(json.datos["avance_venta_objetivo"]) > 1000000 ? '0' : json.datos["avance_venta_objetivo"]) + " %");
      setExhibicionOb(json.datos["exhibidores_objetivo_conf"]);
      setExhibicionReal(json.datos["exhibiciones_real"]);
      setExhibicionAv(json.datos["avance_exhibidores_objetivo"] + " %");
      setVentaCeroTotal(json.datos["total_upcs"]);
      setVentaCeroReal(json.datos["venta_cero_real"]);
      setVentaCeroAv(json.datos["avance_venta_cero_objetivo"] + " %");
      setVentaCeroOb(json.datos["venta_cero_objetivo_conf"] + " %");
      setRutaTotal(json.datos["toda_la_ruta"]);
      setRutaReal(json.datos["asistencias"]);
      setRutaAv(json.datos["avance_cumplimiento_objetivo"] + " %");
      setRutaOb(json.datos["cumplimiento_ruta_conf"] + " %");

      setVentaAvn((parseInt(json.datos["avance_venta_objetivo"]) > 1000000 ? 0 : parseInt(json.datos["avance_venta_objetivo"])));
      setExhibicionAvn(parseInt(json.datos["avance_exhibidores_objetivo"]));
      setVentaCeroAvn(parseInt(json.datos["avance_venta_cero_objetivo"]));
      setRutaAvn(parseInt(json.datos["avance_cumplimiento_objetivo"]));
      setBoton(1);

    } catch {

      setBoton(1);

    }
  }


  useEffect(function () {

    let mounted = true;

    navigation.addListener('focus', () => {
      if (mounted) {
        try {

          fetchData();

        } catch {

          setBoton(1);

        }
      }
    });

    return () => mounted = false;
  }, []);

  const navigation = useNavigation();

  const state = {
    HeadTable1: ['Mensual'],
    DataTable1: [
      ['', 'Objetivo', 'Real', 'Alcance'],
      ['Venta pzas.', ventaOb, ventaReal, ventaAv],
      ['Exhibición', exhibicionOb, exhibicionReal, exhibicionAv]

    ],

    HeadTable2: ['Semanal'],
    DataTable2: [
      ['', 'Total Art.', 'Real\nVenta cero', 'Objetivo', 'Real'],
      ['Venta\ncero', ventaCeroTotal, ventaCeroReal, ventaCeroOb, ventaCeroAv],

    ],
    DataTable3: [
      ['', 'Visitas\nProg.', 'Real\nVisitas', 'Objetivo', 'Visitas\nReales'],
      ['Avance\nde ruta', rutaTotal, rutaReal, rutaOb, rutaAv]

    ],
  }


  const MyBarChart = () => {
    return (
      <>

        <BarChart
          data={{
            labels: ['', 'Venta', 'Exhib.', 'Vta. cero', 'Ruta C.', ''],
            datasets: [
              {
                data: [0, ventaAvn, exhibicionAvn, ventaCeroAvn, rutaAvn, 0],
              },
            ],
          }}
          width={Dimensions.get('window').width - 16}
          height={220}
          yAxisLabel={'%'}
          chartConfig={{
            backgroundColor: '#1cc910',
            backgroundGradientFrom: '#eff3ff',
            backgroundGradientTo: '#efefef',
            decimalPlaces: 0,
            color: (opacity = 1) => `rgba(0, 0, 0, ${opacity})`,
            style: {
              borderRadius: 16,
            },
          }}
          style={{
            marginVertical: 8,
            borderRadius: 16,
            alignItems: 'center'
          }}
        />
      </>
    );
  };


  return (
    <View style={styles.container}>
      <Fondo />
      <Text> </Text>

      <ScrollView  >
        <Text style={styles.TituloText}>Alcance a objetivos</Text>
          <Table borderStyle={{ paddingTop: 40, borderWidth: 1, borderColor: '#CCC', backgroundColor: "#FFF" }} style={{ borderRadius: 10, borderColor: "#CCC", borderStyle: "solid", borderWidth: 1}}>
            <Row data={state.HeadTable1} style={styles.text} textStyle={styles.text} />
            <Rows data={state.DataTable1} style={styles.TableText} textStyle={styles.TableText} />
          </Table>
        <Text> </Text>


        <Table borderStyle={{ paddingTop: 40, borderWidth: 1, borderColor: '#CCC', backgroundColor: "#FFF" }} style={{ borderRadius: 10, borderColor: "#CCC", borderStyle: "solid", borderWidth: 1}}>
          <Row data={state.HeadTable2} style={styles.text} textStyle={styles.text} />
          <Rows data={state.DataTable2} style={styles.TableText} textStyle={styles.TableText} />
        </Table>

        <Table borderStyle={{ paddingTop: 40, borderWidth: 1, borderColor: '#CCC', backgroundColor: "#FFF" }} style={{ borderRadius: 10, borderColor: "#CCC", borderStyle: "solid", borderWidth: 1, marginTop: 10}}>
          <Row data={[]} style={styles.textSimple} textStyle={styles.textSimple} />
          <Rows data={state.DataTable3} style={styles.TableTextSimple} textStyle={styles.TableTextSimple} />
        </Table>

        <Text> </Text>
        <MyBarChart />


      </ScrollView>
    </View>

  );
}

export default DashboardRuta

const styles = StyleSheet.create({
  container: {

    flex: 1,
    backgroundColor: '#f1f1f1',
    alignItems: 'center'

  },
  HeadStyle: {
    height: 20,
    alignContent: "center",
    color: "white",
    backgroundColor: 'white'
  },
  TableText: {
    fontSize: 14,
    textAlign: 'center',
    color: "black",
    fontWeight: 'bold',
    backgroundColor: "#fff",
    borderBottomLeftRadius: 100,
    borderBottomRightRadius: 100,
  },
  text: {
    fontSize: 20,
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: "#23abdc",
    textAlign: 'center',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10
  },
  textSimple: {
    fontSize: 20,
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: "#23abdc",
    textAlign: 'center',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  TableTextSimple: {
    fontSize: 14,
    textAlign: 'center',
    color: "black",
    fontWeight: 'bold',
    backgroundColor: "#fff",
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    borderBottomLeftRadius: 100,
    borderBottomRightRadius: 100,
  },
  TituloText: {
    fontSize: 30,
    margin: 5,
    textAlign: 'center',
    color: "black",
    fontWeight: 'bold'
  }
});